// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__fMht6","bigColWidth":"Table_bigColWidth__1fUEV","biggerColWidth":"Table_biggerColWidth__Tn-pm","row":"Table_row__2bnXv","col":"Table_col__rVwcp"};